export default __webpack_public_path__ + "static/media/Snd2.be019e94.mp3";